import fetchIntercept from 'fetch-intercept';

export const HeaderInterceptor = () => {
  fetchIntercept.register({
    request: function (url, config) {
      // Modify the url or config here
      if(addHeader(url))
      config.headers.appname = 'Hospital Web Chat';
      return [url, config];
    },

    requestError: function (error) {
      // Called when an error occured during another 'request' interceptor call
      return Promise.reject(error);
    },

    response: function (response) {
      // Modify the reponse object
      return response;
    },

    responseError: function (error) {
      // Handle an fetch error
      return Promise.reject(error);
    },
  });
};

const addHeader=(url)=>{
  if(url.includes("getFinalBillDataByOCR"))
  return false

  // Finance API gateway endpoints live on a separate AWS Lambda whose CORS config
  // only allows standard headers. Injecting the custom `appname` header triggers a
  // preflight the Lambda rejects, causing a CORS error. This covers the finance
  // reads (cityops_dashboard) and updateInsDashboard (bd-dashboard finance base).
  if(
    url.includes("get-collection-details") ||
    url.includes("get-collection-status-history") ||
    url.includes("updateInsDashboard")
  )
  return false

  return true
}
